module.exports = __webpack_public_path__ + "static/media/icon_eventos_mercadolocal.fccc0c86.svg";